import { render, staticRenderFns } from "./DeleteNewsButton.vue?vue&type=template&id=3c9727e0&"
import script from "./DeleteNewsButton.vue?vue&type=script&lang=js&"
export * from "./DeleteNewsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports